import api from "../api";

// Privacy settings
export const getPrivacySettings = async () => {
  return await api.getApi().get("/profile/privacy");
};

export const updatePrivacySettings = async (settings) => {
  return await api.getApi().put("/profile/privacy", settings);
};

// User stats (respects privacy)
export const getUserStats = async (userId) => {
  return await api.getApi().get(`/profile/${userId}/stats`);
};
